
import XHeader from 'vux/src/components/x-header/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import payPassword from "vue-pay-password";
import "vue-pay-password/dist/vue-pay-password.css";
export default {
name: "confirm-order",
components: {
XHeader,PopupPicker,Actionsheet,payPassword,XDialog
},
data(){
return{
title:"确认订单",
stu_name:"王小二",
stu_telphone:"12345678901",
order: [
{
src: '../../static/img/shose.png',
title: '帆布鞋',
size: 36,
allsize:[35,36,37,38,39,40],
count:1,
maxcount:20,
price:100,
url: '/component/cell'
}, {
src: '../../static/img/maozi.png',
title: '棒球帽',
size: 'M',
allsize:['S','M','L','XL','XLL'],
count:2,
maxcount:20,
price:50,
url: '/component/cell'
},
{
src: '../../static/img/shose.png',
title: '帆布鞋',
size: 36,
allsize:[35,36,37,38,39,40],
count:1,
maxcount:20,
price:100,
url: '/component/cell'
}],
pay:false,
menus: {
'title': "<p class='qrzf'><span>×</span>确认支付</p>" +
"<p class='total_price'>实付款 <span ref='price'>￥100</span></p>" +
"<p class='sure'>请确认您本次支付的金额</p>",
'confirm': '<span class="confirmbtn">马上支付</span>'
},
showToast:false,
}
},
computed:{
total_price(){
var total = 0;
for(var i = 0;i<this.order.length;i++){
total = total + this.order[i].price*this.order[i].count;
}
return total;
}
},
methods:{
reduce(e,index){
if(parseInt(e.currentTarget.nextElementSibling.value) <= 0){
e.currentTarget.setAttribute('disabled','true');
}else{
var count = parseInt(e.currentTarget.nextElementSibling.value);
count--;
e.currentTarget.nextElementSibling.value = count;
this.$set(this.order[index], 'count', parseInt(e.currentTarget.nextElementSibling.value))
}
},
add(e,index){
if(parseInt(e.currentTarget.previousElementSibling.value) >=20){
e.currentTarget.setAttribute('disabled','true');
}else{
var count = parseInt(e.currentTarget.previousElementSibling.value);
count++;
e.currentTarget.previousElementSibling.value = count;
this.$set(this.order[index], 'count', parseInt(e.currentTarget.previousElementSibling.value))
}
},
oninput(index,val) {
this.$set(this.order, index, val)
},
go(){
this.pay = !this.pay;
console.log(this.$refs);

},
onConfirm(){
this.pay = false;
this.showToast = true;
},
}
}



// WEBPACK FOOTER //
// ./src/components/ConfirmOrder.vue